"use client";

import { createContext } from "react";

/**
 * The LandVest hand-off URL (`getLandvestSuccessorUrl()`), resolved by the root
 * layout on the server — the env it depends on is server-only — and provided
 * to the client chrome by `Providers`. `null` outside the provider.
 */
export const LandvestHandoffContext = createContext<string | null>(null);
